import { useState } from "react";
import { faqs } from "@/mocks/homeData";

export default function FaqSection() {
  const [openIndex, setOpenIndex] = useState<number | null>(0);

  const toggle = (index: number) => {
    setOpenIndex((current) => (current === index ? null : index));
  };

  return (
    <section id="faq" className="w-full bg-background-100 py-16 md:py-24">
      <div className="w-full px-4 md:px-8 max-w-4xl mx-auto">
        <div className="text-center">
          <span className="inline-flex items-center gap-2 text-primary-600 text-sm font-medium">
            <i className="ri-question-answer-line" />
            常见问题
          </span>
          <h2 className="mt-3 font-heading text-foreground-950 text-2xl md:text-4xl">
            关于官网、地址与下载的常见疑问
          </h2>
          <p className="mt-4 text-foreground-600 text-sm md:text-base leading-relaxed">
            这里整理了用户最常问到的问题。点击任意一条即可展开查看详细解答。
          </p>
        </div>

        <div className="mt-10 space-y-3">
          {faqs.map((item, index) => {
            const isOpen = openIndex === index;
            return (
              <div
                key={item.q}
                className="rounded-lg bg-background-50 border border-background-200/70 overflow-hidden"
              >
                <button
                  type="button"
                  onClick={() => toggle(index)}
                  aria-expanded={isOpen}
                  className="w-full flex items-center justify-between gap-4 px-5 py-4 md:px-6 md:py-5 text-left cursor-pointer"
                >
                  <span className="font-heading text-foreground-950 text-base md:text-lg">{item.q}</span>
                  <span
                    className={`shrink-0 w-8 h-8 flex items-center justify-center rounded-full text-lg transition-colors ${
                      isOpen ? "bg-primary-500 text-background-50" : "bg-background-100 text-foreground-600"
                    }`}
                  >
                    <i className={isOpen ? "ri-subtract-line" : "ri-add-line"} />
                  </span>
                </button>
                {isOpen && (
                  <div className="px-5 pb-5 md:px-6 md:pb-6">
                    <p className="text-foreground-600 text-sm leading-relaxed border-t border-background-200/70 pt-4">
                      {item.a}
                    </p>
                  </div>
                )}
              </div>
            );
          })}
        </div>
      </div>
    </section>
  );
}